function toggleDrawer() {
  const drawer = document.querySelector('.mdl-layout__drawer');
  const obfuscator = document.querySelector('.mdl-layout__obfuscator');

  if (drawer) {
    drawer.classList.toggle('is-visible');
  }

  if (obfuscator) {
    obfuscator.classList.toggle('is-visible');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const obfuscator = document.querySelector('.mdl-layout__obfuscator');
  if (obfuscator) {
    obfuscator.addEventListener('click', function () {
      const drawer = document.querySelector('.mdl-layout__drawer');
      if (drawer) {
        drawer.classList.remove('is-visible');
      }
      obfuscator.classList.remove('is-visible');
    });
  }

  const drawerLinks = document.querySelectorAll(
    '.mdl-layout__drawer .mdl-navigation__link'
  );
  drawerLinks.forEach((link) => {
    link.addEventListener('click', function () {
      const drawer = document.querySelector('.mdl-layout__drawer');
      const obfuscator = document.querySelector('.mdl-layout__obfuscator');
      if (drawer) {
        drawer.classList.remove('is-visible');
      }
      if (obfuscator) {
        obfuscator.classList.remove('is-visible');
      }
    });
  });
});
